import mapValues from 'lodash/mapValues';
import * as yup from 'yup';

// src/helpers/validationSchemas/menu/comboSchema.ts
var comboSchema = yup.object().shape({
  name: yup.string().trim().required("nameRequired"),
  menuTypeVersions: yup.lazy(
    (obj) => yup.object(
      mapValues(
        obj,
        () => yup.object({
          posName: yup.string().trim().required("posNameRequired"),
          kdsName: yup.string().trim().required("kdsNameRequired"),
          checkName: yup.string().trim().required("checkNameRequired"),
          onlineName: yup.string().trim().required("onlineNameRequired"),
          comboBasePrice: yup.number().typeError("priceRequired").required("priceRequired"),
          itemGroups: yup.lazy(
            (itemGroupObj) => yup.object(
              mapValues(
                itemGroupObj,
                () => yup.object({
                  posName: yup.string().trim().required("nameRequired"),
                  quantity: yup.number().min(1, "quantityRequired")
                })
              )
            )
          )
        })
      )
    )
  )
});

export { comboSchema };
